import { render } from "./Dash.vue?vue&type=template&id=0a5af18f"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__